import { useEffect, useState } from 'react';

/**
 * Publishes a controlled DataGrid row count one render after its source changes.
 *
 * MUI X v6 rejects a single grid transaction that changes more than one
 * controlled sub-state. Keeping the previous count for the render that receives
 * a new selection lets the selection settle first; this effect then publishes
 * the latest server/optimistic count in its own render.
 */
export default function useDeferredDataGridRowCount(targetRowCount) {
    const [rowCount, setRowCount] = useState(targetRowCount);

    useEffect(() => {
        setRowCount(targetRowCount);
    }, [targetRowCount]);

    return rowCount;
}
